// firebase.js
import { getAuth } from 'firebase/auth';
import { initializeApp } from 'firebase/app';
import { getStorage } from 'firebase/storage';
import { getDatabase } from 'firebase/database';

import { FIREBASE_API } from 'src/config-global';

const firebaseConfig = {
  apiKey: FIREBASE_API.apiKey,
  authDomain: FIREBASE_API.authDomain,
  projectId: FIREBASE_API.projectId,
  storageBucket: FIREBASE_API.storageBucket,
  messagingSenderId: FIREBASE_API.messagingSenderId,
  appId: FIREBASE_API.appId,
  databaseURL: FIREBASE_API.databaseURL,
};

const app = initializeApp(firebaseConfig);
export const firebaseStorage = getStorage(app);
export const firebaseAuth = getAuth(app);
export const firebaseRealtime = getDatabase(app);
